import React from 'react';

const LayoutIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="18"
      height="13.6522"
      rx="2"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M1 5.55094H19" stroke="#555B67" strokeWidth="2" />
    <path d="M6.47837 5.55078V14.6522" stroke="#555B67" strokeWidth="2" />
  </svg>
);

export default LayoutIcon;
